export default __webpack_public_path__ + "static/media/language-title-1.eb66714b.png";